import React from 'react';
import { Contact } from '../../types';
import ContactActionColumn from '../../components/ContactActionColumn';
import styles from './ContactCard.module.css';

interface ContactCardProps {
  contact: Contact;
  onView?: (contact: Contact) => void;
  onEdit?: (contact: Contact) => void;
}

const ContactCard: React.FC<ContactCardProps> = ({
  contact,
  onView,
  onEdit,
}) => {
  // Show only the most important information in the card
  const essentialItems = [
    { label: 'Employee #', value: contact.empNumber },
    { label: 'Occupation', value: contact.occupation },
  ];

  return (
    <div className={styles.card}>
      <div className={styles.cardManageSection}>
        <div className={styles.cardHeader}>
          <div className={styles.cardName} title={contact.empName}>
            {contact.empName}
          </div>
          <div className={styles.cardType}>{contact.empType}</div>
        </div>
        <div className={styles.cardActions}>
          <ContactActionColumn
            contact={contact}
            onView={onView}
            onEdit={onEdit}
          />
        </div>
      </div>
      <div className={styles.cardInfoSection}>
        {essentialItems.map((item) => (
          <div key={item.label} className={styles.cardInfoType}>
            <span className={styles.cardInfoLabel}>{item.label}</span>
            <span className={styles.cardInfoValue} title={item.value}>
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactCard;
